import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { scroller } from 'react-scroll'

import { articleCardsNew } from '../../consts/articlesCardsNew'
// import { selectionImages } from '../../consts/collectionPage'
import { weekSelection } from '../../consts/collectionPageData'
import { menuItems } from '../../consts/menuItems'
// import { collectionsData } from '../../consts/collectionPageData'
import { selectionCardData } from '../../consts/selectionCardData'
import { shuffleArrayExceptLastTwo } from '../../helpers/randomArray'
import { setPageName } from '../../store/page/actions'
import { fetchSelectionsRequest } from '../../store/selections/actions'
import { Feedback } from '../Feedback/Feedback'
import InvestmentMainBanner from '../InvestmentMainBanner/InvestmentMainBanner'
import { MainHero } from '../MainHero/MainHero'
import { NavMenu } from '../NavMenu/NavMenu'
import { NewAnonceList } from '../NewAnonceList/NewAnonceList'
import NewCollectionBanner from '../NewCollectionBanner/NewCollectionBanner'
import { NewBanner } from '../UI/NewBanner/NewBanner'
import { NewBuildings } from './newBuildings/NewBuildings'

const setBodyColor = (color: string) => {
  document.documentElement.style.setProperty('--body-bg', color)
}

const NewMain: FC = () => {
  const dispatch = useDispatch()
  const { hash } = useLocation()
  const location = useLocation()
  const collectionData = weekSelection

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        scroller.scrollTo(hash, {
          delay: 0,
        })
        location.hash = ''
      }, 500)
    }
  }, [hash])

  useEffect(() => {
    dispatch(setPageName('main'))
    setBodyColor('#fff')

    dispatch(
      fetchSelectionsRequest(`${collectionData.id}-${collectionData.id}`)
    )

    return () => {
      setBodyColor('#f7f7f5')
    }
  }, [])

  return (
    <div className='NewMainPage'>
      <NavMenu menuItems={menuItems} />
      <MainHero
        collectionId={collectionData.id}
        btnName='Смотреть подборку недели'
      />
      <NewCollectionBanner
        title={collectionData.anonce?.title}
        lead={collectionData.anonce?.lead}
        id={+collectionData.id}
        img={collectionData.anonce?.imagePath}
        linkLastCard={collectionData.linkLastCard}
        video={collectionData.anonce?.video}
        table={!!collectionData.tables}
        type={collectionData.type}
      />
      <NewBuildings />
      <NewAnonceList
        items={shuffleArrayExceptLastTwo(selectionCardData)}
        title='Все подборки'
        category='/collections/'
        id='#selections'
      />
      <InvestmentMainBanner />
      <NewAnonceList
        items={articleCardsNew}
        title='Статьи'
        category='/article/'
        id='#articles'
      />
      <NewBanner pageType='main' />
      <Feedback />
    </div>
  )
}

export default NewMain

// шаблон для мкльтиподборки
// import {
//   selectionImages,
//   selectionImagesTop,
// } from '../../consts/collectionPage'

// import NewCollectionBannerMulti from '../NewCollectionBannerMulti/NewCollectionBannerMulti'
{
  /* <NewCollectionBannerMulti
        sectionTitle='Топ-7 подборок'
        text='Эти 7 подборок квартир вызвали наибольший интерес читателей РБК'
        items={[
          {
            title: 'Семейный топ: подборка больших квартир',
            lead: 'Квартиры, которые подойдут для большой семьи и любителей простора',
            id: 2,
            img: selectionImagesTop[2],
            views: '67 149',
          },
          {
            title: 'Проекты, которые построят в 2024 году',
            lead: 'Ищем жилье в новостройках, которые будут готовы в 2024 году',
            id: 33,
            img: selectionImagesTop[33],
            views: '4 778',
          },
          {
            title: 'Квартиры с 2 санузлами',
            lead: 'Удобно для большой семьи',
            id: 18,
            img: selectionImagesTop[18],
            views: '36 952',
          },
          {
            title: 'За МКАДом, но с московской пропиской',
            lead: 'Совместить плюсы регистрации в столице с экологичной жизнью в окружении природы',
            id: 12,
            img: selectionImagesTop[40],
            views: '49 508',
          },
          {
            title: 'Всё включено: квартиры с отделкой',
            lead: 'Пропускаем стадию ремонта, распаковываем коробки и принимаем гостей',
            id: 19,
            img: selectionImagesTop[19],
            views: '16 820',
          },
          {
            title: 'Доступные квартиры в пределах МКАД',
            lead: 'Есть миф, что бюджетные квартиры далеко за МКАД. Составили подборку-опровержение',
            id: 24,
            img: selectionImagesTop[24],
            views: '18 866',
          },
          {
            title: 'Проекты рядом с метро и МЦК',
            lead: 'Жилье с идеальной транспортной доступностью',
            id: 32,
            img: selectionImagesTop[3],
            views: '9 129',
          },
        ]}
      /> */
}
